import Head from "next/head";

import PaymentFailurePage from "@/containers/PaymentFailurePage";

const PaymentFailure = () => (
  <>
    <Head>
      <title>Shyft | Payment failure</title>
    </Head>
    <main>
      <PaymentFailurePage />
    </main>
  </>
);

export default PaymentFailure;
